export default "/images/incoming-emails-active-light.svg?2d42efffba24c0e76dc4784646f2da96";